import { api } from '../api-client.config';
import { useInfiniteQuery } from '@tanstack/react-query';
import { Game } from '../types';

const getGames = (params: {
  offset: number;
  limit: number;
  languageCode?: string;
}): Promise<{ games: Game[] }> => api.get('/game', { params });

type GetGamesParams = {
  offset?: number;
  limit?: number;
  languageCode?: string;
};

export const useGetGamesInfiniteQuery = (options?: GetGamesParams) => {
  const { limit = 19, languageCode = '' } = options || {};
  return useInfiniteQuery({
    queryKey: ['games', languageCode],
    queryFn: ({ pageParam }) =>
      getGames({ offset: pageParam * limit, limit, languageCode }),
    getNextPageParam: (lastPage, allPages) => {
      return lastPage?.games?.length < limit ? undefined : allPages?.length;
    },
    initialPageParam: 0,
    select: (data) => {
      // Keep all other properties as they are on page 0.
      if (!data?.pages?.length) return [];
      const mergedGames = data.pages.flatMap((page) => page.games || []);
      return mergedGames;
    },
  });
};
